<template>
  <div class="consult-adviser-wrap" @click="$emit('toAI')">
    <img
      src="../../../images/consult/expertList/serviceAssitance.png"
      class="avatar"
    />
    <span class="t">智能<br />助理</span>
    <span class="r">不知如何选咨询师<br />找我聊聊为您推荐</span>
    <span class="counselor-btn">找我推荐</span>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.consult-adviser-wrap {
  // width: 690px;
  height: 180px;
  border-radius: 30px;
  background-color: #fff;
  box-shadow: 0 4px 20px 0 #ececec;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 30px 0;
  .avatar {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    display: block;
    margin-left: 20px;
  }
  .t {
    font-size: 28px;
    line-height: 32px;
    margin-left: 20px;
    color: #718aff;
    padding-right: 20px;
    border-right: 1px solid #bcc2cf;
  }
  .r {
    margin-left: 20px;
    font-size: 24px;
    color: #6c789c;
    line-height: 34px;
  }
  .counselor-btn {
    width: 196px;
    height: 56px;
    margin-left: 30px;
    border-radius: 50px;
    background-color: #ffa202;
    text-align: center;
    line-height: 56px;
    font-size: 28px;
    color: #fff;
  }
}
</style>
